var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/info-menu/ProductsMenu.tsx",
  _this = this;
import React, { useContext } from 'react';
import { Sheet } from '@wds/sheet';
import { Typography } from '@wds/typography';
import { List } from '@wds/list';
import { Box } from '@wds/box';
import { IconLaunchpad } from '@wds/icons';
import { t, defineMessages } from '@sm/intl';
import { Responsive } from '@wds/responsive';
import { MenuItems } from './MenuItems';
import { Grow3505EnterpriseItem } from '../experiments/grow3505/Grow3505EnterpriseItem';
import HeaderContext from '../../HeaderContext';
import { NavButton } from '../nav-button';
import SkeletonLoader from '../../../../SkeletonLoader';
import useStyles from './useStyles';
import { getProductsItems, getProductsfootnote } from '../../../components/Drawer/getDrawerData';
import { useGrow3505Experiment } from '../experiments/grow3505/useGrow3505';
var COPYPROD = defineMessages({
  PRODUCTS: {
    id: 'ProductsMenu.products',
    defaultMessage: 'Products',
    description: '[Type: Label][Vis.: high] - This is the Products title of the side menu.'
  }
});
var ProductsMenu = function ProductsMenu(_ref) {
  var showProducts = _ref.showProducts,
    toggleProducts = _ref.toggleProducts;
  var _useContext = useContext(HeaderContext),
    lang = _useContext.lang,
    isEUDC = _useContext.isEUDC;
  var classes = useStyles();
  var itemsData = getProductsItems(lang, isEUDC);
  var _useGrow3505Experimen = useGrow3505Experiment(),
    grow3505Loading = _useGrow3505Experimen.loading,
    grow3505Controller = _useGrow3505Experimen.assignmentControls;
  var defaultListItems = /*#__PURE__*/React.createElement(List, {
    interactive: true,
    noRules: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 5
    }
  }, itemsData.map(function (props) {
    return props && /*#__PURE__*/React.createElement(MenuItems, Object.assign({}, props, {
      key: props.title,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 51,
        columnNumber: 27
      }
    }));
  }));
  var grow3505LoaderComponent = /*#__PURE__*/React.createElement(Box, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(SkeletonLoader, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 9
    }
  }), ";"));
  var grow3505ListItems = /*#__PURE__*/React.createElement(List, {
    interactive: true,
    noRules: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 5
    }
  }, itemsData.map(function (props) {
    if (props && props.navItem === 'enterprise') {
      return /*#__PURE__*/React.createElement(Grow3505EnterpriseItem, Object.assign({}, props, {
        key: props.title,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 68,
          columnNumber: 18
        }
      }));
    }
    return props && /*#__PURE__*/React.createElement(MenuItems, Object.assign({}, props, {
      key: props.title,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70,
        columnNumber: 25
      }
    }));
  }));
  return /*#__PURE__*/React.createElement(Responsive, {
    minWidth: "xl",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 5
    }
  }, function (matches) {
    return matches ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NavButton, {
      onClick: toggleProducts,
      label: "Open Products list",
      active: showProducts,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 80,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Box, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 85,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement(IconLaunchpad, {
      title: "Products icon",
      size: "lg",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 86,
        columnNumber: 17
      }
    }))), /*#__PURE__*/React.createElement(Sheet, {
      show: showProducts,
      onClose: toggleProducts,
      showCloseButton: true,
      offsetTop: 48,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 89,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Sheet.Header, {
      header: t(COPYPROD.PRODUCTS),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 95,
        columnNumber: 15
      }
    }), /*#__PURE__*/React.createElement(Sheet.Body, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 96,
        columnNumber: 15
      }
    }, grow3505Loading ? grow3505LoaderComponent : grow3505Controller(grow3505ListItems, defaultListItems), /*#__PURE__*/React.createElement(Box, {
      flexWrap: true,
      pt: 1,
      px: 5,
      pb: 6,
      className: classes.footnote,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 100,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "bodySm",
      color: "dark",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 101,
        columnNumber: 19
      }
    }, /*#__PURE__*/React.createElement("em", {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 102,
        columnNumber: 21
      }
    }, getProductsfootnote())))))) : itemsData.map(function (props) {
      return props && /*#__PURE__*/React.createElement(MenuItems, Object.assign({}, props, {
        key: props.title,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 110,
          columnNumber: 31
        }
      }));
    });
  });
};
export default ProductsMenu;
export { ProductsMenu };
//# sourceMappingURL=ProductsMenu.js.map